import { AxiosResponse, CancelTokenSource } from 'axios';
// eslint-disable
import { getStorageValue } from 'src/hooks/useLocalStorage';
// eslint-disable-next-line import/no-unresolved
import { IAccrualPlanColumns, IPagination, IPayHistory } from 'src/interfaces';

import http from './http';

export type getPayStubPdfParams = {
  ptn: string | string[];
  companyId: string;
  employeeId: string;
  downloadFile: boolean;
};
export interface ICompanyPayHistoryParamsWithPagination extends IPagination {
  [x: string]: string | number | boolean | undefined;
  companyId: string;
  startDate: string;
  endDate: string;
}
class PaymentsService {
  static getAllPayStubPdf(startDate: string, endDate: string) {
    return `${
      process.env.REACT_APP_API_URL
    }payments/generate-all-pdfs?startDate=${startDate}&endDate=${endDate}&token=${getStorageValue(
      'accessToken',
      null
    )}`;
  }

  static getPayStubs(startDate: string, endDate: string) {
    return http.get(`/payments?startDate=${startDate}&endDate=${endDate}`);
  }

  static getPayStubPdf(params: getPayStubPdfParams) {
    return `${process.env.REACT_APP_API_URL}employee-pay-history/generate-pdf?companyId=${
      params.companyId
    }&detailed=false&employeeId=${params.employeeId}&download=${params.downloadFile}&ptn=${
      params.ptn
    }&token=${getStorageValue('accessToken', null)}`;
  }

  static getDetailedPayStubPdf(params: getPayStubPdfParams) {
    return `${process.env.REACT_APP_API_URL}employee-pay-history/generate-pdf?companyId=${
      params.companyId
    }&detailed=true&employeeId=${params.employeeId}&download=${params.downloadFile}&ptn=${
      params.ptn
    }&token=${getStorageValue('accessToken', null)}`;
  }

  static getSelectedPayStubPdf(params: getPayStubPdfParams) {
    return `${process.env.REACT_APP_API_URL}employee-pay-history/generate-pdf?companyId=${
      params.companyId
    }&employeeId=${params.employeeId}&download=${params.downloadFile}&ptn[]=${params.ptn}&token=${getStorageValue(
      'accessToken',
      null
    )}`;
  }

  static getCountPaystubs(source?: CancelTokenSource) {
    if (source?.token) {
      return http.get('/payments/paystubs', {
        cancelToken: source.token,
      });
    }
    return http.get('/payments/paystubs');
  }

  static getW2List(source?: CancelTokenSource) {
    if (source?.token) {
      return http.get('/tax-forms', {
        cancelToken: source.token,
      });
    }
    return http.get('/tax-forms');
  }

  static getW2FormPdf(controlNumber: string, downloadFile = false) {
    return `${process.env.REACT_APP_API_URL}tax-forms/generate-pdf?token=${getStorageValue(
      'accessToken',
      null
    )}&download=${downloadFile}&controlNumber=${controlNumber}`;
  }

  static getCompanyPayHistory(params: ICompanyPayHistoryParamsWithPagination): Promise<{
    data: { items: IPayHistory[]; meta: { totalItems: number } };
  }> {
    let stringParams = '';
    // eslint-disable-next-line no-restricted-syntax
    for (const key in params) {
      if (stringParams === '') {
        stringParams += `${key}=${params[key]}`;
      } else {
        stringParams += `&${key}=${params[key]}`;
      }
    }
    return http.get(`employee-pay-history?${stringParams}`, {
      headers: { companyId: params.companyId },
    });
  }

  static getPayHistoryDetails(
    startDate: string,
    endDate: string,
    companyId: string
  ): Promise<{
    data: {
      totalEmployees: string;
      totalCost: string;
      totalHours: string;
      directDeposits: string;
      paperChecks: string;
    };
  }> {
    return http.get(`/employee-pay-history/details?startDate=${startDate}&endDate=${endDate}`, {
      headers: { companyId },
    });
  }

  static getCompanyPayHistoryChart(params: { companyId: string; startDate: string; endDate: string }): Promise<{
    data: {
      netPay: number;
      benefits: number;
      deductions: number;
      employeeTax: number;
      employerTax: number;
    };
  }> {
    return http.get(`employee-pay-history/pie-chart?startDate=${params.startDate}&endDate=${params.endDate}`, {
      headers: { companyId: params.companyId },
    });
  }

  static runIntegration(): Promise<void> {
    return http.post('/payments/run-integration', {});
  }

  static getAllPayStatements(companyId: string, startDate: string, endDate: string): string {
    return `${
      process.env.REACT_APP_API_URL
    }employee-pay-history/export?companyId=${companyId}&startDate=${startDate}&endDate=${endDate}&token=${getStorageValue(
      'accessToken',
      null
    )}`;
  }

  // eslint-disable-next-line max-len
  static getAccrualPlans(params: {
    page: number;
    limit: number;
    sortBy: string;
    sortDirection: string;
  }): Promise<AxiosResponse> {
    return http.get(
      `/accrual-id-config?page=${params.page}&limit=${params.limit}&sortBy=${params.sortBy}&sortDirection=${params.sortDirection}`
    );
  }

  static getAvailableAccrualIds(): Promise<AxiosResponse> {
    return http.get('/accrual-id-config/available');
  }

  static createNewAccrualIdConfig(values: IAccrualPlanColumns): Promise<void> {
    return http.post('/accrual-id-config', values);
  }

  static deleteAccrualIdConfig(value: string): Promise<void> {
    return http.delete(`/accrual-id-config/${value}`);
  }
}
export default PaymentsService;
